import React from "react";
import { NotificationProps } from "@/features/notification/Notification";
import { PortalDrawer } from "./PortalDrawer";
import { EditDiscountPage } from "./PortalDrawer/pages/EditDiscountPage";

export interface EditDiscountDrawerProps {
  open: boolean;
  onExit: () => void;
  notify: (notification: NotificationProps) => void;
  discountName?: string;
  addressId?: number;
}

const EditDiscountDrawer = ({
  open,
  onExit,
  discountName,
  addressId,
  notify,
}: EditDiscountDrawerProps) => {
  return (
    <PortalDrawer
      open={open}
      onExit={onExit}
      notify={notify}
      goToFirstPage={() => {}}
      title="Discount"
      contents={(nav) =>
        addressId ? (
          <EditDiscountPage
            {...nav}
            discountName={discountName}
            addressId={addressId}
          />
        ) : null
      }
    />
  );
};

export { EditDiscountDrawer };
